module.exports = __webpack_public_path__ + "static/media/TuEn.d1007602.svg";